import { Check, Info, X } from 'lucide-react'
import { percentageLabel, useAffiliateCommissionScopeQuery } from '@entities/partnership'
import {
  scopeBox,
  scopeMetaNo,
  scopeMetaYes,
  scopeName,
  scopeNo,
  scopeNotice,
  scopeNoticeIcon,
  scopeRow,
  scopeTitle,
  scopeYes,
} from './affiliates.css'

const lineKindLabels: Record<string, string> = {
  PRINCIPAL: 'Produto principal',
  BUMP: 'Order bump',
  UPSELL: 'Upsell',
  DOWNSELL: 'Downsell',
}

export function CommissionScopePanel({
  productId,
  commissionPercentage,
}: {
  productId: string
  commissionPercentage: string
}) {
  const scope = useAffiliateCommissionScopeQuery(productId)

  if (scope.isPending || scope.isError || !scope.data) {
    return null
  }

  const { items } = scope.data
  const currentPercentage = scope.data.commissionPercentage
  const agreedRate = Number(commissionPercentage)
  const currentRate = Number(currentPercentage)
  const hasDifferentRate =
    Boolean(currentPercentage?.trim()) &&
    Boolean(commissionPercentage.trim()) &&
    Number.isFinite(agreedRate) &&
    Number.isFinite(currentRate) &&
    agreedRate !== currentRate

  return (
    <div className={scopeBox}>
      <span className={scopeTitle}>Sua comissão neste funil</span>
      {hasDifferentRate && currentPercentage !== undefined ? (
        <div className={scopeNotice} role="note" aria-label="Comissão da sua afiliação">
          <Info size={16} className={scopeNoticeIcon} aria-hidden="true" />
          <p>
            O produtor definiu {percentageLabel(currentPercentage)} como comissão padrão para novas
            afiliações. Sua comissão permanece em {percentageLabel(commissionPercentage)}.
          </p>
        </div>
      ) : null}
      {items.map((item, index) => (
        <div className={scopeRow} key={`${item.lineKind}-${index}`}>
          <span className={scopeName}>
            {item.commissionsAffiliate ? (
              <Check size={14} className={scopeYes} />
            ) : (
              <X size={14} className={scopeNo} />
            )}
            {lineKindLabels[item.lineKind] ?? item.lineKind}
            {item.name ? ` · ${item.name}` : ''}
          </span>
          {item.commissionsAffiliate ? (
            <span className={scopeMetaYes}>{percentageLabel(commissionPercentage)}</span>
          ) : (
            <span className={scopeMetaNo}>{item.blockedReason ?? 'não comissiona'}</span>
          )}
        </div>
      ))}
    </div>
  )
}
